import { useState, useEffect } from 'react';
import { Modal, Button, Row, Col, Spinner } from 'react-bootstrap';
import { downloadDocumentFromUrl } from '../../utils/helpers';

const PdfPreviewModal = ({ show, onHide, data }) => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const onLoad = () => {
            if (!show)
                setLoading(true);
        }
        onLoad();
    }, [show]);

    return (
        <>
            <Modal show={show} onHide={onHide} size="xl" style={{ zIndex: 1050 }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{data?.title}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ padding: 10 }}>
                        <Row>
                            <Col md={12}>
                                {loading &&  <Spinner />}
                                {data?.url && <iframe
                                    onLoad={() => {
                                        setLoading(false)
                                    }
                                    }
                                    src={data?.url}
                                    width="100%"
                                    height="500px"
                                />}
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between">
                    <Button variant="secondary" onClick={onHide}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={() => {
                        downloadDocumentFromUrl(data?.downloadUrl, data?.title + '.pdf');
                    }}>
                        Download
                    </Button>
                </Modal.Footer>
            </Modal >
        </>
    );
};

export default PdfPreviewModal;